import { render, staticRenderFns } from "./QRow.vue?vue&type=template&id=2ebc4646&"
import script from "./QRow.vue?vue&type=script&lang=js&"
export * from "./QRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports